import React, { FC, useMemo } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Benefits from '~/modules/feature-access/components/Benefits';
import PlagiarismReportAnimation from '~/modules/feature-access/components/PlagiarismReportAnimation';
import { getBenefitsList } from '~/modules/feature-access/helpers';
import { FeatureKey, FeatureModule } from '~/modules/feature-access/policy';
import projectConfig from '~/projects/config';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

type Props = {
  plagiarismResult: number;
};

const PlagiarismReport: FC<Props> = ({ plagiarismResult }) => {
  const { t } = useTranslation();

  const benefits = useMemo(() => {
    return getBenefitsList(t)
      .filter(
        (el) =>
          !(
            el.key === FeatureKey.PLAGIARISM_DETAILED_REPORT &&
            el.module === FeatureModule.PLAGIARISM_CHECK
          ),
      )
      .sort(
        (a, b) =>
          Number(b.module === FeatureModule.PLAGIARISM_CHECK) -
          Number(a.module === FeatureModule.PLAGIARISM_CHECK),
      );
  }, []);

  return (
    <div className={styles.container}>
      <Typography
        variant={Typographies.TITLE_LARGE}
        component="div"
        className={styles.title}
      >
        {t('modal:feature_unlock.plagiarism_report_title', {
          project: projectConfig.getProjectName(),
          defaultValue:
            'Upgrade to {{project}} Unlimited To Get Detailed Plagiarism Reports',
        })}
      </Typography>

      <div className={styles.animation}>
        <PlagiarismReportAnimation plagiarismResult={plagiarismResult} />
      </div>

      <Typography
        variant={Typographies.LABEL_LARGE}
        component="div"
        className={styles.subtitle}
      >
        {t(
          'modal:feature_unlock.plagiarism_report_subtitle',
          'Your digital proof of academic integrity',
        )}
      </Typography>

      <Benefits benefits={benefits} />
    </div>
  );
};

export default PlagiarismReport;
